import { alpha, Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

// EditorJS and its plugins ship a light-only stylesheet: near-black toolbar icons and white
// popovers. Their colours are mostly CSS variables, so dark mode re-points those at the theme.
// Global rather than scoped to RichTextEditor, because the same classes render wherever
// an editor is mounted.
export function editorJs(theme: Theme) {
  if (theme.palette.mode !== 'dark') return {};

  const surface = {
    '--color-background': theme.palette.background.paper,
    '--color-text-primary': theme.palette.text.primary,
    '--color-text-secondary': theme.palette.text.secondary,
    '--color-border': theme.palette.divider,
    '--color-border-icon': theme.palette.divider,
    '--color-border-icon-disabled': theme.palette.divider,
    '--color-shadow': alpha(theme.palette.common.black, 0.4),
    '--color-background-item-hover': theme.palette.action.hover,
    '--color-background-item-focus': theme.palette.action.focus,
    '--color-shadow-item-focus': 'transparent',
    '--color-background-icon-active': alpha(theme.palette.primary.main, 0.16),
    '--color-text-icon-active': theme.palette.primary.light,
  };

  const floatingButton = {
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    borderColor: theme.palette.divider,
    '&:hover': { backgroundColor: theme.palette.action.hover },
  };

  return {
    MuiCssBaseline: {
      styleOverrides: {
        '.ce-popover, .ce-inline-toolbar': surface,
        '.ce-toolbar__plus, .ce-toolbar__settings-btn': floatingButton,
        '.ce-block--selected .ce-block__content': {
          background: alpha(theme.palette.primary.main, 0.16),
        },
        '.cdx-search-field': {
          backgroundColor: theme.palette.background.neutral,
          borderColor: theme.palette.divider,
        },
        '.cdx-button, .cdx-input': {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.background.neutral,
          borderColor: theme.palette.divider,
        },
        '.tc-wrap': {
          '--color-background': theme.palette.background.neutral,
          '--color-text-secondary': theme.palette.text.secondary,
          '--color-border': theme.palette.divider,
        },
        '.tc-toolbox': {
          '--toggler-dots-color': theme.palette.text.secondary,
          '--toggler-dots-color-hovered': theme.palette.text.primary,
        },
        '.tc-popover': {
          '--color-background': theme.palette.background.paper,
          '--color-border': theme.palette.divider,
          '--color-background-hover': theme.palette.action.hover,
        },
        '.image-tool': {
          '--bg-color': theme.palette.background.neutral,
          '--border-color': theme.palette.divider,
        },
        '.image-tool--uploading .image-tool__image': {
          backgroundColor: theme.palette.background.neutral,
        },
      },
    },
  };
}
